import React, { useEffect } from 'react';
import Chart from "react-apexcharts";
import { ChartStyles } from "../../ui/charts/ChartStyles.jsx";
import {useTranslation} from "react-i18next";


export default function LineChartRatingCount({ data, width = '100%', height = '320px', className = '' }) {
    const { t} = useTranslation();

    const chartStyles = {
        ...ChartStyles,
        chart: {
            ...ChartStyles.chart,
            id: "pq-insights-chart-" + Math.round((Math.random() * 1000000)),
            type: "area",
        },
        fill: {
            ...ChartStyles.fill,
            type: ['solid'],
        },
        stroke: {
            curve: ['smooth'],
            width: [2],
        },
        xaxis: {
            ...ChartStyles.xaxis,
            type: 'datetime',
            labels: {
                ...ChartStyles.xaxis.labels,
                datetimeUTC: false,
            },
        },
        yaxis: {
            ...ChartStyles.yaxis,
            tickAmount: 3,
            min: 0,
            decimalsInFloat: 0,
        },
    };
    const [dataSeries, setDataSeries] = React.useState({
        reviewsTotal: {
            name: t('Reviews Total'),
            color: "#5D87FF",
            type: 'line',
            zIndex: 30,
            data: []
        },
    });
    const [dataSeriesAsArray, setDataSeriesAsArray] = React.useState([]);


    useEffect(() => {
        if (!data) return;

        let dataSeriesNew = {
            reviewsTotal: { ...dataSeries.reviewsTotal, data: data.reviewsTotal ? [...data.reviewsTotal] : [] },
        };

        Object.keys(data).forEach((key, index) => {
            dataSeriesNew[key].data = data[key];
        });

        setDataSeries(dataSeriesNew);
        setDataSeriesAsArray([dataSeriesNew.reviewsTotal]);
    }, [data]);


    return dataSeries.reviewsTotal.data && dataSeries.reviewsTotal.data.length ? (
        <Chart type="area" options={chartStyles} series={dataSeriesAsArray} width={width} height={height} className={className} />
    ) : '';
}